import { makeStyles as originalMakeStyles } from '@fluentui/react-components';

/**
 * Wrapper around makeStyles that bypasses strict Griffel type checking
 */
export const makeStyles = (styles: any) => {
    return originalMakeStyles(styles);
};
